import { DashboardPage } from "../../../types";
import { CustomSchema } from "./types";

export const dashboardPageSchema: CustomSchema<DashboardPage>[] = [
    {
        name: "name",
        label: "Name",
        component: "input",
        required: true,
        uniqe: true,
    },
    {
        name: "title",
        label: "Title",
        component: "input",
    },
    {
        name: "description",
        label: "Description",
        component: "input",
    },
    {
        name: "url",
        label: "URL",
        component: "input",
    },
];
